import React from "react";

const Loading = () => {
  return (
    <div>
      <div className="Loading">
        <h4>📚 My Diary 📚</h4>
      </div>
    </div>
  );
};

export default Loading;
